export default "/assets/images/award-img-02.d88f6cde9b136d16.png";